import { useEffect, useRef } from 'react';

import { crossTabChannel } from 'src/utils/cross-tab';

// ----------------------------------------------------------------------

/**
 * 別タブから届いた MessageClass のメッセージを受ける（src/utils/cross-tab）。
 *
 * handler は毎レンダーで変わってよい（最新を ref で持つ）。
 * 購読し直すのは MessageClass が変わったときだけ。
 * ref はレンダー中に更新する（v2-form-item-builder.js の isDirtyRef と同じ形）。
 * 届くのは別タブからのイベントで、レンダーの途中に呼ばれることはない。
 *
 * @param {typeof import('src/utils/cross-tab').CrossTabMessage} MessageClass
 * @param {(message) => void} handler
 */
export function useCrossTabMessage(MessageClass, handler) {
  const savedHandler = useRef(handler);
  savedHandler.current = handler;

  useEffect(
    () => crossTabChannel.subscribe(MessageClass, (message) => savedHandler.current?.(message)),
    [MessageClass]
  );
}
